
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import { mapState, mapActions } from "vuex";
import wx from "weixin-js-sdk";
import { getCookie} from './../common/js/utils.js';

export default {
components: {
Tabbar,
TabbarItem,
XButton

},
created() {
let self = this;
self.partnerId = this.$route.query.partnerId;


self.platform = this.$config.platform
if (self.platform == 'partner') {
self.partner = true
} else if (self.platform == 'homeH5') {
self.homeH5 = true
} else if (self.platform == 'appointmentH5') {
self.appointmentH5 = true
} else if (self.platform == 'miniprogram') {
self.miniprogram = true
} else if(self.platform == 'yuexiu') {
self.yuexiu = true
}



console.log(self.platform)
},
computed: {
path() {
return this.$route.path;
},











},
data() {
return {
partnerId: '',
platform: '',
partner: false,
miniprogram: false,
homeH5: false,
appointmentH5: false,
yuexiu:false

};
},
methods: {
gomain() {
let self = this;
wx.miniProgram.navigateTo({
url: "/pages/index"
})
}
}
};



// WEBPACK FOOTER //
// ./src/components/TabbarIndex.vue